__turbopack_context__.v({
  "separator": "MobileViewSeparator-module__Jp1bzW__separator",
});
